

module.exports = __webpack_require__.stylable.create(
    "Ribbon3830361791",
    {"classes":{"root":"Ribbon3830361791__root","ribbon":"Ribbon3830361791__ribbon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Ribbon3830361791",
    null
);
